<div *ngIf="!cartao" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>


<div>
  <form ngNativeValidate (submit)="save()">
    <div class="panel panel-default ">
      <div class="panel-heading"> Dados Pessoais
      </div>
      <div class="panel-body">
        <div class="form-group col-xs-12">
          <label for="nome">Nome Completo</label>
          <input type="text" id="nome" name="cartao.nome" [(ngModel)]="cartao.nome" class="form-control input-sm"
            maxlength="256" required>
        </div>
        <div class="form-group col-xs-12 col-md-4">
          <label for="sexo">Sexo</label>
          <select id="sexo" class="form-control input-sm" name="cartao.sexo" [(ngModel)]="cartao.sexo" required>
            <option></option>
            <option *ngFor="let sexo of sexos" [value]="sexo">{{ sexo }}</option>
          </select>
        </div>
        <div class="form-group col-xs-12 col-md-4">
          <div class="">
            <label for="nascimento">Nascimento</label>
            <input type="text" class="form-control input-sm" id="nascimento" placeholder="01/01/1990"
              [(ngModel)]="cartao.novaDataNascimento" name="cartao.novaDataNascimento" uiData required>
          </div>
          <p class="help-block">Formato: DD/MM/AAAA</p>
        </div>
        <div class="form-group col-xs-12 col-md-4 {{ cartao.documentoValido ? '' : 'has-error' }}">
          <label for="documento">Documento</label>
          <div class="input-group">
            <div class="input-group-btn">
              <button type="button" class="btn btn-sm" [ngClass]="{'app-btn-best': documentoTipo === 'CPF'}"
                (click)="documentoTipo = 'CPF'">
                <i [ngClass]="{'fa fa-check': documentoTipo === 'CPF'}"></i> CPF
              </button>

              <button type="button" class="btn btn-sm " [ngClass]="{'app-btn-best': documentoTipo === 'CNPJ'}"
                (click)="documentoTipo = 'CNPJ'">
                <i [ngClass]="{'fa fa-check': documentoTipo === 'CNPJ'}"></i> CNPJ
              </button>
            </div>
            <input type="text" id="documento" class="form-control input-sm" [(ngModel)]="cartao.documento"
              name="cartao.documento" (ngModelChange)="cartao.documentoValido = true" maxlength="14"
              *ngIf="documentoTipo === 'CPF'" UiCpf required>

            <input type="text" id="documento" class="form-control input-sm" [(ngModel)]="cartao.documento"
              name="cartao.documento" (ngModelChange)="cartao.documentoValido = true" maxlength="18"
              *ngIf="documentoTipo === 'CNPJ'" UiCnpj required>
          </div>

          <p class="help-block">Formato: {{ documentoTipo === 'CPF' ? '00000000000' : '00000000000000' }}</p>
        </div>

        <div *ngIf="documentoTipo === 'CNPJ'" class="form-group col-xs-12 col-md-4">
          <label for="documento">IE</label>
          <div class="checkbox">
            <label>
              <input type="checkbox" [(ngModel)]="cartao.inscricaoEstadualIsento" name="cartao.inscricaoEstadualIsento">
              Isento
            </label>
          </div>
          <div *ngIf="!cartao.inscricaoEstadualIsento">
            <input type="text" id="documentoOficial" class="form-control input-sm"
              [(ngModel)]="cartao.inscricaoEstadual" name="cartao.inscricaoEstadual" uiOutroDocumento>
            <p class="help-block">Formato: Apenas números e/ou letras</p>
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-default">
      <div class="panel-heading"> Telefone Residencial</div>
      <div class="panel-body">
        <div class="col-xs-4 col-md-3 {{ !cartao.telefoneResidencial.ddd ? 'has-error' : '' }}">

          <label for="dddResidencial">DDD</label>
          <input type="tel" id="dddResidencial" class="form-control input-sm"
            [(ngModel)]="cartao.telefoneResidencial.ddd" name="cartao.telefoneResidencial.ddd" maxlength="2">
        </div>
        <div class="col-xs-8 col-md-6 {{ !cartao.telefoneResidencial.numero ? 'has-error' : '' }}">
          <label for="numeroResidencial">Numero</label>
          <input type="tel" id="numeroResidencial" class="form-control input-sm"
            [(ngModel)]="cartao.telefoneResidencial.numero" maxlength="9" name="cartao.telefoneResidencial.numero"
            UiNumeros>
        </div>
        <div class="col-xs-4 col-md-3">
          <label for="ramalResidencial">Ramal</label>
          <input type="tel" id="ramalResidencial" class="form-control input-sm col-xs-4"
            [(ngModel)]="cartao.telefoneResidencial.ramal" name="cartao.telefoneResidencial.ramal" maxlength="4"
            UiNumeros>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading"> Telefone Celular</div>
      <div class="panel-body">
        <div class="col-xs-12">
          <div class="col-xs-4 col-md-3 form-group {{!cartao.telefoneCelular.ddd ? 'has-error' : ''}}">
            <label for="dddCelular">DDD</label>
            <input type="tel" id="dddCelular" class="form-control input-sm" [(ngModel)]="cartao.telefoneCelular.ddd"
              maxlength="2" UiNumeros name="cartao.telefoneCelular.ddd" required>
          </div>
          <div class="col-xs-8 col-md-6  {{ !cartao.telefoneCelular.numero ? 'has-error' : '' }}">
            <label for="numeroCelular">Numero</label>
            <input type="tel" id="numeroCelular" class="form-control input-sm"
              [(ngModel)]="cartao.telefoneCelular.numero" maxlength="9" name="cartao.telefoneCelular.numero" UiNumeros
              required>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading"> Telefone Comercial
      </div>
      <div class="panel-body">
        <div class="col-xs-4 col-md-3 ">
          <label for="dddComercial">DDD</label>
          <input type="tel" id="dddComercial" class="form-control input-sm" [(ngModel)]="cartao.telefoneComercial.ddd"
            maxlength="2" name="cartao.telefoneComercial.ddd" UiNumeros>
        </div>
        <div class="col-xs-8 col-md-6">
          <label for="numeroComercial">Numero</label>
          <input type="tel" id="numeroComercial" class="form-control input-sm"
            [(ngModel)]="cartao.telefoneComercial.numero" maxlength="9" name="cartao.telefoneComercial.numero"
            UiNumeros>
        </div>
        <div class="col-xs-4 col-md-3">
          <label for="ramalComercial">Ramal</label>
          <input type="tel" id="ramalComercial" class="form-control input-sm"
            [(ngModel)]="cartao.telefoneComercial.ramal" maxlength="4" name="cartao.telefoneComercial.ramal" UiNumeros>
        </div>
      </div>
    </div>

    <app-endereco></app-endereco>

    <div class="col-xs-12 text-center" style="margin-top: 20px;margin-bottom: 60px;">
      <button type="submit" id="btnSalvar" class="btn btn-success-v2" [disabled]="!cartao.enderecoResidencial.numero">
        Salvar
      </button>
    </div>
  </form>
</div>

<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/form/form.component.html